import React from "react";

// Shared renderer for the 7 CMS-driven "Things to Know" entries (highlights,
// included, not-included, accessibility, important-info, meeting-point,
// cancellation). The CMS payload is trusted (internal admin) so we render via
// dangerouslySetInnerHTML and rely on the @tailwindcss/typography `prose`
// utility for list-marker styling — no need to ship react-html-parser for
// these blocks on the critical path.
const CmsEntry = ({ data }: { data: any }) => {
  const html = data?.[0]?.content;
  if (!html) return null;
  return (
    <div
      className="prose prose-sm max-w-none prose-li:my-0 prose-ul:list-[circle] prose-ul:ml-4"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

export default CmsEntry;
